import * as React from "react";
import * as Styled from "./TabsStyles";
var Tabs = function (_a) {
    var children = _a.children;
    return (React.createElement(Styled.TabsContainer, null,
        React.createElement(Styled.Tabs, null, children)));
};
export default Tabs;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFicy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlRhYnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sS0FBSyxLQUFLLE1BQU0sT0FBTyxDQUFDO0FBQy9CLE9BQU8sS0FBSyxNQUFNLE1BQU0sY0FBYyxDQUFDO0FBTXZDLElBQU0sSUFBSSxHQUFHLFVBQUMsRUFBbUI7UUFBakIsUUFBUSxjQUFBO0lBQ3RCLE9BQU8sQ0FDTCxvQkFBQyxNQUFNLENBQUMsYUFBYTtRQUNuQixvQkFBQyxNQUFNLENBQUMsSUFBSSxRQUFFLFFBQVEsQ0FBZSxDQUNoQixDQUN4QixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==